module.exports = __webpack_public_path__ + "static/media/RVTN10-1.c6e7b86f.jpg";